import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as AmberAlertTriangle } from '../../../assets/images/svg/amber-alert-triangle.svg';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import Paragraph from '../../Paragraph/Paragraph';
import themeColors from '../../../assets/styles/themeColors';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  svg {
    width: 48px;
    height: 48px;
    display: block;
  }
`;

const BodyTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${themeColors.colorTextPrimary};
  text-align: center;
  margin-bottom: 8px;
`;

const SellFromHomeLockedModal = ({ isOpen, close, title, message }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      close={close}
      hideHeader
      verticalCenter
      isCenterModal
    >
      <ModalBody style={{ padding: '20px 40px' }}>
        <IconWrapper>
          <AmberAlertTriangle />
        </IconWrapper>
        <BodyTitle>{title}</BodyTitle>
        <Paragraph centerText>{message}</Paragraph>
        <ModalButtons
          isVertical
          textTransform="none"
          marginTop
          showOnlyPrimary
          primaryButtonProps={{
            label: t('common.close'),
            onClick: close,
          }}
        />
      </ModalBody>
    </Modal>
  );
};

SellFromHomeLockedModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default SellFromHomeLockedModal;
